import { useContext, useEffect, useMemo, useState } from 'react';

import { Space } from 'antd';

import useNotification from '@/hooks/notifications';

import SortableTable from '@Components//Tables/SortableTable';

import { orderHighlighted } from '@/utils/fetchFunctions/highlight';
import useFetchListData from '@/hooks/useFetchListData';

import { TopicContext } from '@/context/topicContext/topicContext';

export default function OrderHighlightedMedias() {
	const { openNotification } = useNotification();
	const { topicId } = useContext(TopicContext);

	const params = useMemo(() => {
		return {
			url: `topics/${topicId}/medias/highlighted`,
			selectedMedia: true,
			mediaType: 'all'
		};
	}, []);

	const {data, loading, error, getData} = useFetchListData({params, useDefaultParams: true});

	const sortedData = useMemo(() => data ? [...data]?.sort((a, b) => a?.position - b?.position) : [], [data]);
	const [loadingChange, setLoadingChange] = useState(false);

	useEffect(() => {
		if (error) {
			showError(error);
		}
	}, [error]);

	function showError (error) {
		openNotification({message: 'Something went wrong!', description: error.message || null, type: 'error'});
	}

	const saveItems = async (items) => {
		setLoadingChange(true);

		orderHighlighted({url: `/topics/${topicId}/medias/highlighted/order`, ids: items.map(item => item.id)})
			.then(() => {
				setLoadingChange(false);
				getData();
			})
			.catch(err => {
				setLoadingChange(false);
				showError(err);
			});
	};

	return (
		<Space size="large" direction='vertical' style={{width: '100%'}} >
			<>
				<SortableTable
					data= {sortedData}
					loading={loading || loadingChange}
					saveItems={saveItems}
					idKey='mediaId'
				/>
			</>
		</Space>
	);
}